import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import RegisterForm from "./components/RegisterForm";
import VotingPage from "./components/VotingPage";
import WinnerPage from "./components/WinnerPage";
import GifLoader from "./components/GifLoader";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Welcome from "./components/Welcome_tem";
import ThankYouPage from "./components/ThankYouPage";
import HolidayLightMap from "./components/displayMap";
import "./styles/index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const location = useLocation(); // <-- hook to get current path

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // Define contest phases
  const today = new Date();
  const dec10 = new Date("2025-12-10T23:59:59");
  const dec11 = new Date("2025-12-20T00:00:00");
  const dec26 = new Date("2025-12-24T23:59:59");

  let phase = "register";
  if (today >= dec11 && today < dec26) phase = "vote";
  else if (today >= dec26) phase = "winner";

  if (loading) {
    return (
      <div className={`loader-wrapper ${fadeOut ? "fade-out" : "fade-in"}`}>
        <GifLoader />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <div
        className={`page-content ${
          location.pathname === "/" ? "welcome-page-content" : ""
        }${
    location.pathname === "/register" ? "register-page-content" : ""
  }${
    location.pathname === "/thank-you" ? "thankYou-page-content" : ""
  }`}
      >
        <Routes>
          {/* Welcome page */}
          <Route path="/" element={<Welcome />} />

          {/* Contest pages */}
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/voting" element={<VotingPage />} />
          <Route path="/winner" element={<WinnerPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/holidayLight-map" element={<HolidayLightMap />} />


          {/* Catch-all: redirect based on phase */}
     <Route path="*"
      element={ location.pathname === "/holidayLight-map" ? (
         <HolidayLightMap />
          ) : phase === "register" ? (
             <Navigate to="/register" replace /> 
             ) : phase === "vote" ? ( 
             <Navigate to="/voting" replace />
              ) : 
              ( <Navigate to="/thank-you" replace />

               )
                } 
                />
        </Routes>
      </div>
<Footer/>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
}

export default App;

